<template>
  <div class="container-fluid">
    <div class="row">
      <main role="main" class="w-full" :class="{ subpage: subpage }">
        <WarningMessage v-if="warningMessage">
          {{ warningMessage }}
        </WarningMessage>
        <slot name="header">
          <div
            v-if="title"
            class="flex flex-wrap items-start pb-0 mb-3 justify-between page-header-content"
          >
            <div class="flex items-start">
              <h3 v-if="subpage" class="page-header-2">{{ title }}</h3>
              <h1 v-else class="page-header-1">{{ title }}</h1>
              <slot name="afterTitle"></slot>
            </div>
            <div
              class="d-flex flex-wrap max-w-full min-w-0 [&>*]:min-w-0 [&>*]:max-w-full actions-section"
            >
              <slot name="actions"></slot>
            </div>
          </div>
        </slot>
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script>
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
export default {
  components: {
    WarningMessage
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    subpage: {
      type: Boolean,
      default: false
    },
    warningMessage: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.subpage {
  padding: 0 !important;
}
</style>
